export const pricePackageANumeric = 2203;
export const pricePackageBNumeric = 3183;
export const pricePackageCNumeric = 1691;
export const pricePackageA = `€ ${pricePackageANumeric}`;
export const pricePackageB = `€ ${pricePackageBNumeric}`;
